'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _PricingSelectors = require('../../../selectors/PricingSelectors');

var _PriceDisplay = require('../../common/pricing/PriceDisplay');

var _PriceDisplay2 = _interopRequireDefault(_PriceDisplay);

var _H = require('UIComponents/elements/headings/H4');

var _H2 = _interopRequireDefault(_H);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PricesContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ShoppingCartPrices__PricesContainer'
})(['text-align:center;padding:6px;margin-bottom:20px;']);

var StyledPriceDisplay = (0, _styledComponents2.default)(_PriceDisplay2.default).withConfig({
  displayName: 'ShoppingCartPrices__StyledPriceDisplay'
})(['font-size:20px;font-weight:600;']);

function ShoppingCartPrices(_ref) {
  var pricingDependencies = _ref.pricingDependencies,
      totalPrice = _ref.totalPrice;
  var currencyCode = pricingDependencies.currencyCode;

  return _react2.default.createElement(
    PricesContainer,
    null,
    _react2.default.createElement(
      _H2.default,
      { className: 'm-bottom-2' },
      _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.shoppingCart.monthlyCost' })
    ),
    _react2.default.createElement(StyledPriceDisplay, {
      price: totalPrice.monthly.calculatedPrice,
      currencyCode: currencyCode
    })
  );
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ShoppingCartPrices);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/shopping-cart/ShoppingCartPrices.js
// module id = 708
// module chunks = 3 4